<template>
  <div
    class="info-img-wrapper"
    @mouseenter="show = true"
    v-click-outside="() => (show = false)"
    @click.stop="show = !show"
  >
    <!-- Кнопка с иконкой "i" (как у тебя сейчас) -->
    <div class="info-img" :class="{ active: show }">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="info-icon"
      >
        <path
          d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          stroke="#8E9EBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <!-- Попап со списком статей -->
    <div
      v-if="show"
      class="info-tooltip articles-tooltip"
      :style="tooltipStyle"
    >
      <div v-if="title" class="articles-header">
        {{ title }}
      </div>

      <button
        v-for="item in items"
        :key="item.title || item.title"
        type="button"
        class="articles-item"
        @click="go(item.link)"
      >
        <span class="articles-item__icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 7.5C12 5.29086 10.2091 3.5 8 3.5H2V18.5H9C10.6569 18.5 12 19.8431 12 21.5M12 7.5V21.5M12 7.5C12 5.29086 13.7909 3.5 16 3.5H22V18.5H15C13.3431 18.5 12 19.8431 12 21.5"
              stroke="#409FFF"
              stroke-width="2"
              stroke-linejoin="round"
            />
          </svg>
        </span>

        <!-- стрелка слева, как на скрине -->

        <span class="articles-item__title">
          {{ item.title }}
        </span>
        <span class="articles-item__chevron">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="#8E9EBB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <!-- иконка “книга” справа -->
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoArticlesTooltip',
  props: {
    align: {
      type: String,
      default: 'left', // 'left' | 'right'
      validator: v => ['left', 'right'].includes(v)
    },
    // [{ title: string, link: string }]
    items: {
      type: Array,
      default: () => []
    },
    // заголовок сверху (например "מאמרים")
    title: {
      type: String,
      default: ''
    },
    // если true – используем vue-router, иначе обычный window.open
    useRouter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    tooltipStyle() {
      return this.align === 'right'
        ? { right: '0', left: 'auto' }
        : { left: '0', right: 'auto' };
    }
  },
  methods: {
    go(link) {
      if (!link) {
        return;
      }
      if (this.useRouter && this.$router) {
        this.$router.push(link);
      } else {
        window.open(link, '_blank');
      }
    }
  }
};
</script>

<style scoped>
.info-img {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.info-icon path {
  transition: stroke 0.2s ease;
}

/* hover по самой иконке */
.info-img:hover .info-icon path {
  stroke: #409fff !important;
}

/* если хочешь, чтобы работало и при hover по всей wrapper */
.info-img-wrapper:hover .info-icon path {
  stroke: #409fff !important;
}
.info-img.active .info-icon path {
  stroke: #409fff !important;
}
.info-img-wrapper {
  position: relative;
  display: inline-flex;
}

/* базовый попап, можешь подстроить под свои current .info-tooltip */
.info-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(21, 29, 61, 0.15);
  min-width: 260px;
  z-index: 100;
  padding: 8px 0;
}

.articles-header {
  font-size: 13px;
  font-weight: 600;
  color: #1a2340;
  padding: 4px 16px 8px;
  text-align: right;
}

.articles-item {
  width: 100%;
  border: none;
  background: transparent;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.articles-item + .articles-item {
  border-top: 1px solid #f0f2f7;
}

.articles-item__title {
  flex: 1;
  margin: 0 8px;
  font-size: 13px;
  color: #1a2340;
  text-align: right;
}

.articles-item__chevron,
.articles-item__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
</style>
